export default function nonEmptyString(str: string) {
  return typeof str === 'string' && str.length > 0;
}
